<template>
    <div class="card">
        <div class="pb-0 card-header mb-0">
            <h6>{{ question.text.toUpperCase() }}</h6>
            <p class="text-sm">
                <i class="fa fa-arrow-up text-success"></i>
                <span class="font-weight-bold">{{ total }}</span>
                {{ detail2 }}
            </p>
        </div>
        <div class="p-3 card-body">
            <div class="chart">
                <canvas :id="`chart-line${question.id}`" class="chart-canvas" height="300"></canvas>
            </div>
        </div>
    </div>
</template>
  
<script>
import Chart from "chart.js/auto";

export default {
    name: "estadisticas",

    props: {
        question: {
            type: Object
        },
        // detail1: {
        //     type: String,
        //     default: "4% more",
        // },
        detail2: {
            type: String,
            default: "Respuestas",
        },
    },
    data() {
        return {
            total: 0,
            labels: [],
            data: []
        };
    },
    created() {
        // console.log(this.question)
        this.data = [];
        this.labels = this.question.answers.map(answer => {
            this.total += answer.answer_users_count
            this.data.push(answer.answer_users_count)
            return answer.text
        });
    },
    mounted() {
        var ctx1 = document.getElementById(`chart-line${this.question.id}`).getContext("2d");

        var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

        gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
        gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
        gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");
        new Chart(ctx1, {
            type: "line",
            data: {
                labels: this.labels, //RESPUESTAS: MUY BUENO BUENO REGULAR MALO
                datasets: [
                    {
                        label: "Total respuestas",
                        tension: 0.4,
                        borderWidth: 0,
                        pointRadius: 0,
                        borderColor: "#4BB543",
                        backgroundColor: gradientStroke1,
                        // eslint-disable-next-line no-dupe-keys
                        borderWidth: 3,
                        fill: true,
                        data: this.data, //CANTIDAD DE RESPUESTAS MUY BUENO: 50 MALO: 30: SUMA = total de respuestas
                        maxBarThickness: 6,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                interaction: {
                    intersect: false,
                    mode: "index",
                },
                scales: {
                    y: {
                        grid: {
                            drawBorder: false,
                            display: true,
                            drawOnChartArea: true,
                            drawTicks: false,
                            borderDash: [5, 5],
                        },
                        ticks: {
                            display: true,
                            padding: 10,
                            color: "#fbfbfb",
                            font: {
                                size: 11,
                                family: "Open Sans",
                                style: "normal",
                                lineHeight: 2,
                            },
                        },
                    },
                    x: {
                        grid: {
                            drawBorder: false,
                            display: false,
                            drawOnChartArea: false,
                            drawTicks: false,
                            borderDash: [5, 5],
                        },
                        ticks: {
                            display: true,
                            color: "#ccc",
                            padding: 20,
                            font: {
                                size: 11,
                                family: "Open Sans",
                                style: "normal",
                                lineHeight: 2,
                            },
                        },
                    },
                },
            },
        });
    },
};
</script>
  